import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { EventService } from 'app/shared/services/event.service';
import { NotificationService } from 'app/shared/services/notification.service';
import { SubscriptionService } from 'app/shared/services/subscription.service';
import { TerminalService } from 'app/shared/services/terminal.service';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import { finalize, forkJoin, Observable, of, switchMap } from 'rxjs';
import { LineUpService } from 'app/shared/services/lineup.service';
import { faTicket } from '@fortawesome/free-solid-svg-icons';
import { CellRenderService } from 'app/shared/services/cell-render.service';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { SupportService } from 'app/shared/services/support.service';

@Component({
    selector       : 'support',
    templateUrl    : './support.component.html',
    styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit 
{
  supportForm: UntypedFormGroup;
  faTicket = faTicket;

/**
 * Constructor
 */
constructor(
    private _formBuilder: UntypedFormBuilder,
    private _terminalService: TerminalService,
    private _eventService: EventService,
    private _notifcationService: NotificationService,
    @Optional() public matDialogRef: MatDialogRef<SupportComponent>,
    private formBuilder: FormBuilder,
    private _subscriptionService: SubscriptionService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private route: ActivatedRoute,
    private _lineUpService: LineUpService,
    private _notification: NotificationService,
    private _cellRendererService: CellRenderService,
    private _supportService: SupportService 

     
)
{
}
ngAfterViewInit(): void {
   

}

// -----------------------------------------------------------------------------------------------------
// @ Lifecycle hooks
// -----------------------------------------------------------------------------------------------------

/**
 * On init
 */
ngOnInit(): void
{
    this.supportForm = this._formBuilder.group({
        category: ['', Validators.required],
        description: [null, Validators.required],
        severity: [[], Validators.required]
    })


}

onSend() {
    const formValue = this.supportForm.getRawValue();

    if (!this.supportForm.valid) {
      this._notifcationService.toNotifyInfo('Fill up all required fields', {}, false);
      return;
    }

    this._supportService.send(formValue)
    .pipe(finalize(() => {
    }))
    .subscribe((response) => {
      
      this._notifcationService.toNotifySucess('You will receive an e-mail of confimation')
      this.matDialogRef.close(true);
  
    });
     
}
  
}
